export default __webpack_public_path__ + "static/media/3.d4917f82.png";